import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CelebrationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"celebration"}/>
}
